import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UpgradeButtonProps {
    className?: string;
    label?: string;
}

const UpgradeButton: React.FC<UpgradeButtonProps> = ({
                                                         className = '',
                                                         label = 'Upgrade to Premium',
                                                     }) => {
    const navigate = useNavigate();

    return (
        <button
            className={`inline-flex w-56 items-center justify-center rounded-lg bg-crumborange px-4 py-2
                text-white font-medium text-center hover:opacity-90 focus-visible:outline-none
                focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-crumborange ${className}`}
            data-testid="upgrade-btn"
            onClick={() => navigate('/upgrade/subscription')}
        >
            {label}
        </button>
    );
};

export default UpgradeButton;